import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';

class Header {
  /* animation header with gsap & scrollmagic */

  animationHeader() {
    const controllerHeader = new ScrollMagic.Controller();
    const tlHeader = new TimelineMax()
        .fromTo('.header', 0.3, {
          boxShadow: '0px 0px 10px rgba(0,0,0,0)',
        }, {
          boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
          ease: Power0.easeNone,
        }, 0.1)
        .to('.header-background', 0.3,{
          height: '100%',
          ease: Power2.easeInOut,
        }, 0.1)
        .to('.site-nav .menu li a', 0.3, {
          color: '#f03e4f',
          ease: Power2.easeInOut,
        }, 0.1)
        .to('.site-name svg path', 0.3, {
          fill: '#f03e4f',
          ease: Power2.easeInOut,
        }, 0.1);

    const sceneHeader = new ScrollMagic.Scene({
      triggerElement: '#triggerHeader', offset: 5, duration: 0, triggerHook: 0,
    })
        .setTween(tlHeader)
        .setClassToggle(".header", "animated") // add class toggle
        // .addIndicators({name: "1 (duration: 300)"}) // add indicators (requires plugin)
        .addTo(controllerHeader);
  }
}

export { Header };
